import { useState } from "react";

const MIN_PASSWORD_LENGTH = 12;

const PasswordSetupForm = ({
  title,
  description,
  accountEmail = "",
  accountName = "",
  submitLabel = "Save password",
  onSubmit,
}) => {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");

  const handleSubmit = async (event) => {
    event.preventDefault();
    setErrorMessage("");
    setSuccessMessage("");

    if (password.length < MIN_PASSWORD_LENGTH) {
      setErrorMessage(`Password must be at least ${MIN_PASSWORD_LENGTH} characters.`);
      return;
    }

    if (password !== confirmPassword) {
      setErrorMessage("Passwords do not match.");
      return;
    }

    try {
      setSubmitting(true);
      const result = await onSubmit(password);
      setSuccessMessage(result?.message || "Password saved successfully.");
    } catch (error) {
      const errors = error.body?.errors;
      if (Array.isArray(errors) && errors.length) {
        setErrorMessage(errors.join(" "));
      } else {
        setErrorMessage(error.message || "Unable to save password.");
      }
    } finally {
      setSubmitting(false);
    }
  };

  if (successMessage) {
    return (
      <div className="auth-login-card panel-card">
        <p className="eyebrow">Midpoint</p>
        <h1>{title}</h1>
        <p className="auth-login-message" role="status">
          {successMessage}
        </p>
        <p className="muted auth-login-footnote">
          <a className="auth-login-link" href="/login?passwordUpdated=1">
            Go to sign in
          </a>
        </p>
      </div>
    );
  }

  return (
    <div className="auth-login-card panel-card">
      <p className="eyebrow">Midpoint</p>
      <h1>{title}</h1>
      <p className="muted">{description}</p>

      {accountEmail || accountName ? (
        <p className="muted auth-login-message">
          {accountName ? `${accountName} · ` : ""}
          {accountEmail}
        </p>
      ) : null}

      <form className="auth-login-form" onSubmit={handleSubmit}>
        <label>
          <span>New password</span>
          <input
            type="password"
            name="password"
            autoComplete="new-password"
            value={password}
            onChange={(event) => setPassword(event.target.value)}
            disabled={submitting}
            required
            minLength={MIN_PASSWORD_LENGTH}
          />
        </label>

        <label>
          <span>Confirm password</span>
          <input
            type="password"
            name="confirmPassword"
            autoComplete="new-password"
            value={confirmPassword}
            onChange={(event) => setConfirmPassword(event.target.value)}
            disabled={submitting}
            required
            minLength={MIN_PASSWORD_LENGTH}
          />
        </label>

        {errorMessage ? (
          <p className="auth-login-error" role="alert">
            {errorMessage}
          </p>
        ) : null}

        <button
          type="submit"
          className="report-submit-cta auth-login-submit"
          disabled={submitting}
        >
          {submitting ? "Saving…" : submitLabel}
        </button>
      </form>
    </div>
  );
};

export default PasswordSetupForm;
